import React, { useContext } from "react";
import { Modal } from "antd";
import Api from "../../services/ServiceApi";
import { useSelector } from "react-redux";
import { authUserContext } from "../../contexts";
import ApproveProcessForm from "./approve_process_form";

export default function ApproveProcessModal({
  title = "Approve Form",
  visible, // Modal Visible
  callbackFunction, //
  sendData,
  wrapClassName = "bbtec-theme",
  renderComponents = null,
  defaultApprove = null,
  disableRadio = false,
}) {
  const { locale } = useContext(authUserContext);
  const { masterLang: language, factUpdate } = useSelector(
    (state) => state.masterLang
  );

  console.log("sendData",sendData)
  return (
    <Modal
      title={
        <>
          <img
            src={Api.absoluteUrl(`/icon/bbtec/body/approve.svg`)}
            alt={
              title
                ? title
                : factUpdate
                ? language[locale]["approve_form"]
                : `Approve Form`
            }
            title={
              title
                ? title
                : factUpdate
                ? language[locale]["approve_form"]
                : `Approve Form`
            }
          />
          <h4>
            {title
              ? title
              : factUpdate
              ? language[locale]["approve_form"]
              : `Approve Form`}
          </h4>
        </>
      }
      footer={null}
      centered
      visible={visible}
      onCancel={() => callbackFunction}
      wrapClassName={wrapClassName}
      closable={false}
    >
      <ApproveProcessForm
        sendData={sendData}
        callbackFunction={callbackFunction}
        renderComponents={renderComponents}
        defaultApprove={defaultApprove}
        disableRadio={disableRadio}
      ></ApproveProcessForm>
    </Modal>
  );
}
